import { Link } from '@backstage/core-components';
import { useApp } from '@backstage/core-plugin-api';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const useStyles = makeStyles(theme => ({
  root: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(2),
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 1),
    marginLeft: theme.spacing(-1),
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.primary,
    '&:hover': {
      background: theme.palette.action.hover,
      textDecoration: 'none',
    },
    '&:hover $external': { opacity: 1 },
  },
  external: { marginLeft: 'auto', fontSize: 14, opacity: 0 },
}));

/** The entity's links as a slim list for the side rail. */
export const QuickLinks = () => {
  const classes = useStyles();
  const app = useApp();
  const { entity } = useEntity();
  const links = entity.metadata.links ?? [];
  if (!links.length) return null;

  return (
    <Box className={classes.root}>
      <Typography variant="subtitle2" gutterBottom>
        Links
      </Typography>
      {links.map(link => {
        const Icon =
          (link.icon && app.getSystemIcon(link.icon)) || LanguageIcon;
        return (
          <Link key={link.url} to={link.url} className={classes.link}>
            <Icon fontSize="small" />
            <span>{link.title ?? link.url}</span>
            <OpenInNewIcon className={classes.external} />
          </Link>
        );
      })}
    </Box>
  );
};
